'use strict';

var tslib = require('tslib');
var React = require('react');
var superEllipse = require('@alfalab/core-components/icon-view/super-ellipse');
var ScrewdriverPaintBrushMIcon = require('@alfalab/icons-glyph/ScrewdriverPaintBrushMIcon');
var vars = require('@alfalab/core-components/vars');
var InternetOffMIcon = require('@alfalab/icons-glyph/InternetOffMIcon');
var core_statusScreen_statusScreen = require('../../status-screen.js');
var core_bankContacts_bankContacts = require('../../../bank-contacts/bank-contacts.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var TECHNICAL_ERROR_ICONS_MAP = {
    tech: React__default.default.createElement(ScrewdriverPaintBrushMIcon.ScrewdriverPaintBrushMIcon, null),
    connection: React__default.default.createElement(InternetOffMIcon.InternetOffMIcon, null),
    'page-deleted': React__default.default.createElement(ScrewdriverPaintBrushMIcon.ScrewdriverPaintBrushMIcon, null),
};
var StatusScreenTechnicalError = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'tech' : _b, _c = _a.shouldShowBankContacts, shouldShowBankContacts = _c === void 0 ? false : _c, restProps = tslib.__rest(_a, ["type", "shouldShowBankContacts"]);
    var topAddon = React__default.default.createElement(superEllipse.SuperEllipse, { backgroundColor: vars.colorDarkBgSecondaryInverted }, TECHNICAL_ERROR_ICONS_MAP[type]);
    var showBankContacts = type === 'tech' && shouldShowBankContacts;
    return React__default.default.createElement(core_statusScreen_statusScreen.StatusScreen, tslib.__assign({ topAddons: topAddon, innerCustomAddon: showBankContacts && React__default.default.createElement(core_bankContacts_bankContacts.BankContacts, { title: "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 24/7" }) }, restProps));
};

exports.StatusScreenTechnicalError = StatusScreenTechnicalError;
exports.TECHNICAL_ERROR_ICONS_MAP = TECHNICAL_ERROR_ICONS_MAP;
